const emptyObject = {
  title: '',
  name: '',
  surname: '',
  phone_number: '',
  additional_phone_number: '',
  email: '',
  preferred_contact_channel: '',
};

export const additionalContacModule = {
  state: {
    additional_contact_person_state: false,
  },
  mutations: {
    setAdditionalContactPerson(state, object) {
      this.state.changed_object.additional_contact_person[object.key] =
        object.value;
    },
    setAdditionalContactPersonState(state, additional_contact_person_state) {
      state.additional_contact_person_state = additional_contact_person_state;
    },
    resetAdditionalContactPerson() {
      this.state.changed_object.additional_contact_person = emptyObject;
    },
  },
  getters: {
    getAdditionalContactPersonState: (state) => {
      return state.additional_contact_person_state;
    },
  },
  actions: {},
};
